import { render } from "./IntoCloud.vue?vue&type=template&id=546f41aa"
const script = {}

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__